export default "/assets/38bcfba2c37aac23453faf21d14511fb.woff";